<form nz-form class="form">
  <div class="drawer-form-wrapper">
    <div
      class="behaviour-card-sec"
      *ngIf="caseParams && caseParams.case && caseParams.case.student">
      <div class="header-with-cta mb-24">
        <h3 class="title s-18">
          {{ caseParams.case.student.firstName }}
          {{ caseParams.case.student.lastName }}
        </h3>
      </div>
      <div class="card-content-wrapper">
        <div class="content">
          <h4 class="title">Date Of Birth</h4>
          <p class="desc">
            <svg-icon
              src="/assets/icon/icon-calendar.svg"
              class="icon s-16"></svg-icon>
            {{ caseParams.case.student.dateOfBirth | date: 'MM/dd/yyyy' }}
          </p>
        </div>
        <div class="content">
          <h4 class="title">Supervisor</h4>
          <p class="desc">
            <svg-icon
              src="/assets/icon/icon-supervisor.svg"
              class="icon s-16"></svg-icon>
            {{ caseParams.case.supervisorName }}
          </p>
        </div>
        <div class="content">
          <h4 class="title">Gender</h4>
          <p class="desc">
            <svg-icon
              src="/assets/icon/icon-male.svg"
              class="icon s-18"></svg-icon>
            {{ caseParams.case.student.gender }}
          </p>
        </div>
      </div>
    </div>
    <nz-tabset
      [(nzSelectedIndex)]="selectedTabIndex"
      *ngIf="caseParams.groupedBehaviors; else nodata">
      <nz-tab
        *ngFor="
          let category of caseParams.groupedBehaviors | keyvalue;
          let i = index
        "
        [nzTitle]="category.key">
        <app-behavior-category-data
          [categoryData]="category.value"></app-behavior-category-data>
      </nz-tab>
    </nz-tabset>
    <ng-template #nodata>
      <app-no-data
        [title]="'No Behavior'"
        [desc]="'No Behavior Defined'"
        [icon]="'/assets/icon/icon-face-happy.svg'">
      </app-no-data>
    </ng-template>
  </div>
</form>
